// @flow

import moment from 'moment';

import {
  DELETE_CHALLENGES,
  MY_COMPLETED_CHALLENGES,
  MY_LIVE_CHALLENGES,
  MY_UPCOMING_CHALLENGES,
  CHALLENGE_ENTRIES
} from '../constants/apiTypes';
import * as challengesApi from '../api/challenges';
import * as types from '../constants/actionTypes';
import { LIVE_CHALLENGE_POLL_DURATION } from '../constants/pollDurations';
import { sendQuery, stopChallengePolls } from './challengeListActions';

export function deleteChallenges(ids: Array<string>) {
  return {
    type: types.API_CALL,
    api: DELETE_CHALLENGES,
    request: challengesApi.deleteChallenges(ids),
    ids
  };
}

export function getMyChallengeEntries(challengeId) {
  return {
    type: types.API_CALL,
    api: CHALLENGE_ENTRIES,
    request: challengesApi.getMyChallengeEntries(challengeId),
    id: challengeId
  };
}

export function startMyChallengeEntriesPoll(challengeId) {
  return (dispatch: Dispatch<*>) => {
    dispatch({
      type: types.START_API_POLL,
      key: CHALLENGE_ENTRIES,
      duration: LIVE_CHALLENGE_POLL_DURATION,
      getApiCall: () => ({
        api: CHALLENGE_ENTRIES,
        request: challengesApi.getMyChallengeEntries(challengeId),
        id: challengeId,
        quiet: true
      })
    });
  };
}

export function startMyLiveChallengesPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { myChallenges } = getState();

    dispatch(
      sendQuery({
        key: MY_LIVE_CHALLENGES,
        query: challengesApi.getMyChallenges,
        queryParams: {
          embed: ['current_user_score'],
          status: 'running'
        },
        poll: true,
        duration: LIVE_CHALLENGE_POLL_DURATION,
        runStraightAway: force || !myChallenges.live.hasInitialised
      })
    );
  };
}

export function fetchMyLiveChallenges() {
  return sendQuery({
    key: MY_LIVE_CHALLENGES,
    query: challengesApi.getMyChallenges,
    queryParams: {
      embed: ['current_user_score'],
      status: 'running'
    },
    poll: false
  });
}

export function stopMyChallengeEntriesPoll() {
  return stopChallengePolls(CHALLENGE_ENTRIES);
}

export function stopMyLiveChallengesPoll() {
  return stopChallengePolls(MY_LIVE_CHALLENGES);
}

export function startMyChallengesPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { myChallenges } = getState();

    dispatch(
      sendQuery({
        key: MY_UPCOMING_CHALLENGES,
        query: challengesApi.getMyChallenges,
        queryParams: {
          embed: ['current_user_score'],
          status: 'active'
        },
        runStraightAway: force || !myChallenges.upcoming.hasInitialised
      })
    );

    dispatch(
      sendQuery({
        key: MY_COMPLETED_CHALLENGES,
        query: challengesApi.getMyChallenges,
        queryParams: {
          embed: ['current_user_score'],
          min_end_time: moment()
            .subtract({ days: 10 })
            .startOf('day')
            .toISOString(),
          sort_by: 'start_time:desc',
          status: 'closed'
        },
        runStraightAway: !myChallenges.completed.hasInitialised
      })
    );

    dispatch(
      sendQuery({
        key: MY_LIVE_CHALLENGES,
        query: challengesApi.getMyChallenges,
        queryParams: {
          embed: ['current_user_score'],
          status: 'running'
        },
        runStraightAway: !myChallenges.live.hasInitialised
      })
    );
  };
}

export function stopMyChallengesPoll() {
  return stopChallengePolls([MY_COMPLETED_CHALLENGES, MY_LIVE_CHALLENGES, MY_UPCOMING_CHALLENGES]);
}
